export function silenceAbort(error: unknown) {
  if (error instanceof DOMException) {
    if (error.name === "AbortError") {
      return;
    }
  }
  throw error;
}
